export const INSTITUTION_ADMIN_DASHBOARD_PATH = "/institution/dashboard";

export const PARTNER_PATH = "/institution/partners";

export const STUDENT_STATISTICS_PATH = "/institution/student-statistics";

export const RESEARCH_CENTRE_PATH = "/institution/research-centres";

export const CAMPUS_PATH = "/institution/campuses";

export const ACCREDITATIONS_PATH = "/institution/accreditations";

export const RESEARCH_MAPPING_PATH = "/institution/research-mappings";

export const FACILITY_PATH = "/institution/facilities";

export const AWARD_PATH = "/institution/awards";

export const MILESTONE_PATH = "/institution/awards/milestones";

export const INDUSTRY_COLLABORATION_PATH =
  "/institution/industry-collaborations";

export const FACULTY_PATH = "/institution/faculties";

export const TECHNOLOGY_INITIATIVE_PATH =
  "/institution/faculties/technology-initiatives";

export const NOTABLE_ALUMNUS_PATH = "/institution/notable-alumni";

export const INSTITUTION_EVENTS_PATH = "/institution/events";

export const AFFILIATION_PATH = "/institution/affiliations";

export const ACADEMIC_PROGRAM_PATH = "/institution/programs";

export const SPECIALISATION_PATH = "/institution/programs/specialisations";

export const PUBLICATION_PATH = "/institution/publications";

export const STAFF_PATH = "/institution/staff";

export const INSTITUTION_PROFILE_PATH = "/institution/institutions/:id/profile";

export const PUBLICATION_TYPE_PATH = "/institution/publication-types";

export const INSTITUTION_FOCUS_AREA_PATH =
  "/institution/setup/institution-specialisations";

export const TITLE_PATH = "/institution/setup/titles";

export const LICENSE_CATEGORIES_PATH =
  "/institution/setup/licensing-categories";

export const STAFF_STATISTICS_PATH = "/institution/staff-statistics";

export const GRAD_STATISTICS_PATH = "/institution/grad-statistics";

export const INSTITUTION_ADMIN_PROFILE_PATH = "/institution/admin/profile";
